"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _divider = _interopRequireDefault(require("../Divider/divider"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _item = _interopRequireDefault(require("./item"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Nav = function Nav(_ref) {
  var children = _ref.children,
      vertical = _ref.vertical,
      fontSmall = _ref.fontSmall,
      props = _objectWithoutProperties(_ref, ["children", "vertical", "fontSmall"]);

  var classes = ['co-nav', {
    'co-nav--vertical': vertical
  }];
  var allowedModifiers = {
    fontSmall: fontSmall
  };
  return _react.default.createElement(_styler.default, {
    classNames: classes,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("nav", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("ul", null, children));
  });
};

Nav.Divider = function () {
  return _react.default.createElement(_divider.default, {
    vertical: true
  });
};

Nav.Item = _item.default;
Nav.propTypes = {
  /** {---} Sequence of: @@<Nav.Item>@@ (required, min: 1), @@<Nav.Divider>@@ (optional, max: ∞). @@<Nav.Divider>@@ can't be used when @@vertical@@ is truthy). */
  children: _propTypes.any,

  /** Can't have @@<Nav.Divider>@@ as children. */
  vertical: _propTypes.bool,
  fontSmall: _propTypes.bool
};
var _default = Nav;
exports.default = _default;
Nav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Nav",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "{---} Sequence of: @@<Nav.Item>@@ (required, min: 1), @@<Nav.Divider>@@ (optional, max: \u221E). @@<Nav.Divider>@@ can't be used when @@vertical@@ is truthy)."
    },
    "vertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Can't have @@<Nav.Divider>@@ as children."
    },
    "fontSmall": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};